require('./RAAdditionalContributionView.scss');
require('./RAAdditionalContributionView.override.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const moment = require('moment');
import classnames from 'classnames';

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');
const RAOneLineSymbolAmount = require('../../components/commons/RAOneLineSymbolAmount/RAOneLineSymbolAmount');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const {
    ModalUsPersonBlock,
} = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RALandingSuccess = require('../../components/RALandingSuccess/RALandingSuccess');
const RAAccordionWizard = require('../../components/RAAccordionWizard/RAAccordionWizard');
const RAAccordionWizardStep = require('../../components/RAAccordionWizardStep/RAAccordionWizardStep');
const RAPortfolioBox = require('../../components/RAPortfolioBox/RAPortfolioBox');
const RAContributionPeriodicity = require('../../components/RAContributionPeriodicity/RAContributionPeriodicity');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const OKModal = require('components/commons/OKModal/OKModal');

// @actions
const brokerMyInvestments = require('actions/brokerMyInvestments');
const raAdditionalContributionActions = require('../../actions/RAAdditionalContribution');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    recordLink,
    recordLinkV2,
    recordProcess,
    PROC_RA_NEW_CONTRIBUTION,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');
const CurrencyHelper = require('utilities/currencyHelper');
const { validTypesAccounts } = require('../../utilities/RAAccountsHelper');
const { getFirstNChars } = require('utilities/stringHelper');
const {
    showWarningMessage,
    getPorfolioOperationStatus,
} = require('../../utilities/RAStatusPortfolioOperationHelper');
// @constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER,
    EURO_SYMBOL,
    EURO_TEXT,
    FIRST_STEP,
    SECOND_STEP,
    MYPROFILE_BROKER_URL,
    BROKER_PG_ROBO_URL,
} = require('constants/index');
const {
    PASS_MONEY_ID,
    TRANSFER_SEPA_NATIONAL_PERIODICITY_ID,
} = require('constants/operationTypes');
const {
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
    CONTRIBUTION_PERIOD_PUNCTUAL,
    DATE_FORMAT,
    GO_BACK_URL,
    RAINITIAL_CONTRIBUTION_MIN,
    RAINITIAL_CONTRIBUTION_MAX,
    WIZARD_POSITION_FIRST,
    WIZARD_POSITION_MIDDLE,
    WIZARD_POSITION_LAST,
    MYPROFILE_BROKER_ROBO_URL,
    MAXIMUM_PERIODIC_CONTRIBUTION,
    VALID_ACCOUNT_TYPES,
    VALID_ACCOUNT_SUBTYPES,
} = require('../../raConstants/index');
const {
    SUITABILITY_CONTRIBUTION_MAINTENANCE_POPUP,
} = require('constants/flagBasedFeatures');

const AMOUNT_CARD = 'AMOUNT_CARD';
const ACCOUNT_CARD = 'ACCOUNT_CARD';
const OTP_CARD = 'OTP_CARD';

const buildAmountObject = amount => ({
    currency: EURO_SYMBOL,
    amount,
});

//@contact center
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const PRINTED_DOCUMENTS_ANSWER = {
    YES: 'YES',
};

class RAAdditionalContributionView extends React.Component {
    constructor() {
        super();

        this.state = {
            activeCard: AMOUNT_CARD,
            openModalMaintenance: false,
        };

        this.handleFeatureModal = this.handleFeatureModal.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleAccountSectionClick = this.handleAccountSectionClick.bind(
            this,
        );
        this.handleAmountSectionClick = this.handleAmountSectionClick.bind(
            this,
        );
        this.handleContributionDayChange = this.handleContributionDayChange.bind(
            this,
        );
        this.handleOTPSectionClick = this.handleOTPSectionClick.bind(this);
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
        this.handlePortfolioChange = this.handlePortfolioChange.bind(this);
        this.handleCloseModalMaintenance = this.handleCloseModalMaintenance.bind(
            this,
        );
    }

    componentDidMount() {
        const {
            fetchMyInvestments,
            immGlobalPosition,
            match: {
                params: { portfolioId },
            },
            immFlagBasedFeatures,
        } = this.props;

        if (!immGlobalPosition.get('hasRoboHired')) {
            fetchMyInvestments();
        }

        if (!!portfolioId) {
            this.props.setPortfolio(portfolioId);
        }

        this.props.fetchFeatureFlag();

        const isContributionMaintenancePopup = immFlagBasedFeatures.get(
            SUITABILITY_CONTRIBUTION_MAINTENANCE_POPUP,
        );
        if (isContributionMaintenancePopup) {
            this.setState({
                openModalMaintenance: true,
            });
            recordLinkV2({
                action: 'open',
                format: 'modal',
                component: 'modal/technicalUpdateDeferOperations',
                element: 'full',
                eventCategory: PROC_RA_NEW_CONTRIBUTION,
                eventAction: 'technicalUpdateDeferOperations',
                eventLabel: 'full',
            });
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immAdditionalContribution,
            immGlobalPosition,
            getAdditionalContributionPDF,
        } = this.props;
        const prevVisibleStep = prevProps.immAdditionalContribution.get(
            'visibleStep',
        );
        const nextVisibleStep = immAdditionalContribution.get('visibleStep');

        if (prevVisibleStep !== nextVisibleStep) {
            const portfolioId = immAdditionalContribution.get('portfolio');
            const selectedStrategy = immGlobalPosition.getIn([
                'portfolios',
                portfolioId,
                'product',
                'typeOfProduct',
            ]);
            const eventTag = 'robo cartera ' + selectedStrategy;
            if (nextVisibleStep === 2 && isPrintOfficeMode()) {
                getAdditionalContributionPDF();
            }
            recordLink(
                PROC_RA_NEW_CONTRIBUTION,
                PROC_STEP + (nextVisibleStep + 1),
                eventTag,
            );
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    handleAmountSectionClick() {
        this.setState({ activeCard: AMOUNT_CARD });
    }

    handleAccountSectionClick() {
        this.setState({ activeCard: ACCOUNT_CARD });
    }

    handleOTPSectionClick() {
        this.setState({ activeCard: OTP_CARD });
    }

    handleFeatureModal(periodicContributionSelected) {
        const { immRAFeatureFlag } = this.props;
        if (
            !immRAFeatureFlag.get('additionalContribution') &&
            periodicContributionSelected === CONTRIBUTION_PERIOD_PUNCTUAL
        ) {
            this.props.featureModalToggle();
        } else if (
            !immRAFeatureFlag.get('recurringContribution') &&
            periodicContributionSelected != CONTRIBUTION_PERIOD_PUNCTUAL
        ) {
            this.props.featureModalToggle();
        }
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    getBreadcrumb() {
        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText('raCancelPlan-managementBreadcrumb'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: formatText('raAdditionalContribution-newContribution'),
            },
        ];
    }

    getPeriodicityTranslation(periodicity) {
        switch (periodicity) {
            case CONTRIBUTION_PERIOD_DAILY:
                return formatText('raContributionPeriodicity-daily');
            case CONTRIBUTION_PERIOD_WEEKLY:
                return formatText('raContributionPeriodicity-weekly');
            case CONTRIBUTION_PERIOD_MONTHLY:
                return formatText('raContributionPeriodicity-monthly');
            case CONTRIBUTION_PERIOD_PUNCTUAL:
                return formatText('raContributionPeriodicity-punctual');
            default:
                return '?';
        }
    }

    handleAccountChange(accountId) {
        const accountBalance = this.props.immAccounts.getIn([
            'byId',
            accountId,
            'balances',
            'availableBalance',
        ]);
        this.props.setAdditionalContributionAccount(accountId, accountBalance);
    }

    handlePortfolioChange(portfolio) {
        const { immGlobalPosition } = this.props;
        const selectedStrategy = immGlobalPosition.getIn([
            'portfolios',
            portfolio.value,
            'product',
            'typeOfProduct',
        ]);
        const customData = {
            processDetail: 'robo cartera ' + selectedStrategy,
        };

        recordProcess(PROC_RA_NEW_CONTRIBUTION, PROC_START, customData);
        this.props.setPortfolio(portfolio.value);
    }

    handlePeriodicityChange(ev) {
        const { immAdditionalContribution } = this.props;
        const amount = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]);
        if (
            amount > MAXIMUM_PERIODIC_CONTRIBUTION &&
            ev.value != CONTRIBUTION_PERIOD_PUNCTUAL
        ) {
            this.props.setRecurringContributionAmount(
                MAXIMUM_PERIODIC_CONTRIBUTION,
            );
        }
        this.props.setPeriodicity(ev.value);
        this.handleFeatureModal(ev.value);
    }

    handleContributionDayChange(ev) {
        const { immAdditionalContribution } = this.props;
        const selectedDay = parseInt(ev.currentTarget.dataset.id);
        if (selectedDay !== immAdditionalContribution.get('contributionDay')) {
            this.props.setContributionDay(selectedDay);
        }
    }

    buildDisclaimer(status, hasGoal) {
        if (status !== 'NoOrdersNoRebalancing') {
            const hasGoalKey = hasGoal ? 'Goal' : 'Portfolio';
            const valueKey = `raAdditionalContribution-raAdditionalContribution_disclaimer${hasGoalKey}${status}`;
            if (!__CONTACT_CENTER__) {
                return (
                    <div className="ra-additional-contribution-view__disclaimer-message">
                        <OKMessage>
                            <FormattedText value={valueKey} />
                        </OKMessage>
                    </div>
                );
            } else {
                const titleKey = `raAdditionalContribution-raAdditionalContribution_disclaimerTitle${hasGoalKey}${status}`;
                return (
                    <div className="ra-additional-contribution-view__disclaimer-message">
                        <BlockInfo>
                            <div className="ra-additional-contribution-view__diclaimer-content">
                                <FormattedText
                                    className="ra-additional-contribution-view__disclaimer-title"
                                    value={titleKey}
                                />
                                <FormattedText value={valueKey} />
                            </div>
                        </BlockInfo>
                    </div>
                );
            }
        }
    }

    buildContributionStep() {
        const {
            immAdditionalContribution,
            immGlobalPosition,
            setRecurringContributionAmount,
        } = this.props;
        const amount = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]);
        const recurringTransfers = immGlobalPosition.getIn([
            'portfolios',
            immAdditionalContribution.get('portfolio'),
            'recurringTransfers',
        ]);
        const hasGoal = immGlobalPosition.getIn([
            'portfolios',
            immAdditionalContribution.get('portfolio'),
            'hasGoal',
        ]);

        const immPortfolioState = immGlobalPosition.getIn([
            'portfolios',
            immAdditionalContribution.get('portfolio'),
            'state',
        ]);
        let tradingOnHold, strategyChange, monthlyRebalancing;
        if (immAdditionalContribution.get('portfolio') && immPortfolioState) {
            tradingOnHold = immPortfolioState.get('tradingOnHold');
            strategyChange = immPortfolioState.get('strategyChange');
            monthlyRebalancing = immPortfolioState.get('monthlyRebalancing');
        }
        let disclaimerSection;

        if (
            showWarningMessage(
                tradingOnHold,
                strategyChange,
                monthlyRebalancing,
            )
        ) {
            const status = getPorfolioOperationStatus(
                tradingOnHold,
                strategyChange,
                monthlyRebalancing,
            );
            disclaimerSection = this.buildDisclaimer(status, hasGoal);
        }

        let startDate, endDate, dateInfo;

        if (immAdditionalContribution.get('visibleStep') === FIRST_STEP) {
            return (
                <div>
                    <div className="ra-additional-contribution-view__info-wrapper">
                        <FormattedText value="raAdditionalContribution-raAdditionalContribution_contributionCopy" />
                    </div>
                    <RAContributionPeriodicity
                        amount={amount}
                        allowPunctual={true}
                        disableSelect={!!recurringTransfers}
                        hideFocusZero={true}
                        keepZeroAndEmpty={true}
                        errorState={amount < 1 && amount != 0}
                        errorMessage={formatText(
                            'raAdditionalContribution-raAdditionalContribution_error',
                        )}
                        selectedDay={immAdditionalContribution.get(
                            'contributionDay',
                        )}
                        selectedPeriodicity={immAdditionalContribution.get(
                            'periodicity',
                        )}
                        onDayClick={this.handleContributionDayChange}
                        onPeriodicityChange={this.handlePeriodicityChange}
                        onRecurringContributionChange={
                            setRecurringContributionAmount
                        }
                    />
                    {disclaimerSection}
                </div>
            );
        } else {
            if (
                immAdditionalContribution.get('periodicity') !==
                CONTRIBUTION_PERIOD_PUNCTUAL
            ) {
                switch (immAdditionalContribution.get('periodicity')) {
                    case CONTRIBUTION_PERIOD_DAILY:
                        startDate = moment().add(1, 'days');
                        break;
                    case CONTRIBUTION_PERIOD_WEEKLY:
                        startDate = moment().add(7, 'days');
                        break;
                    case CONTRIBUTION_PERIOD_MONTHLY:
                        startDate = moment().date(
                            immAdditionalContribution.get('contributionDay'),
                        );
                        if (startDate.isBefore(moment())) {
                            startDate = startDate.add(1, 'month');
                        }
                        break;
                    default:
                        startDate = moment();
                }

                endDate = hasGoal
                    ? moment(
                          immGlobalPosition.getIn([
                              'portfolios',
                              immAdditionalContribution.get('portfolio'),
                              'goalInformation',
                              'goalDate',
                          ]),
                      )
                    : null;

                dateInfo = [
                    <div key="startDate" className="col-md-2">
                        <strong>
                            <FormattedText value="raAdditionalContribution-raAdditionalContribution_startDate" />
                        </strong>
                        <br />
                        {startDate.format(DATE_FORMAT)}
                    </div>,
                    hasGoal ? (
                        <div key="endDate" className="col-md-2">
                            <strong>
                                <FormattedText value="raAdditionalContribution-raAdditionalContribution_endDate" />
                            </strong>
                            <br />
                            {endDate.format(DATE_FORMAT)}
                        </div>
                    ) : null,
                ];
            }

            return (
                <div className="row">
                    <div className="col-md-2">
                        <strong>
                            <FormattedText value="raAdditionalContribution-amount" />
                        </strong>
                        <br />
                        {CurrencyHelper.getFormattedString({
                            amount,
                            currency: EURO_SYMBOL,
                        })}
                    </div>
                    <div className="col-md-2">
                        <strong>
                            <FormattedText value="raAdditionalContribution-raAdditionalContribution_periodicity" />
                        </strong>
                        <br />
                        {this.getPeriodicityTranslation(
                            immAdditionalContribution.get('periodicity'),
                        )}
                    </div>
                    {dateInfo}
                </div>
            );
        }
    }

    buildContributionSourceStep() {
        const { immAdditionalContribution, immAccounts } = this.props;
        const stockContractOptions = validTypesAccounts(
            immAccounts,
            VALID_ACCOUNT_TYPES,
            VALID_ACCOUNT_SUBTYPES,
        );
        const immSelectedAccount = immAdditionalContribution.getIn([
            'hireData',
            'selectedAccount',
        ]);
        const accountId = immSelectedAccount.get('id');
        const selectedAccountBalance = this.props.immAccounts.getIn([
            'byId',
            accountId,
            'balances',
            'availableBalance',
        ]);
        let titular;
        let titularLabel;

        if (accountId) {
            titular = immAccounts.getIn(['byId', accountId, 'accountHolder']);
            titularLabel = (
                <div className="ra-additional-contribution-view__titular-label">
                    <FormattedText
                        value="raAdditionalContribution-titularLabel"
                        injectedStrings={[titular]}
                    />
                </div>
            );
        }

        if (immAdditionalContribution.get('visibleStep') === SECOND_STEP) {
            return (
                <div>
                    <FormattedText value="raAdditionalContribution-raAdditionalContribution_contributionSourceCopy" />
                    <div className="ra-additional-contribution-view__dropdown-container">
                        <StocksContractDropdown
                            errorMessage={formatText(
                                'raHireManagementPlanStep2-accountErrorMessage',
                            )}
                            errorState={immAdditionalContribution.getIn([
                                'hireData',
                                'selectedAccount',
                                'errorFlag',
                            ])}
                            label="raAdditionalContribution-raAdditionalContribution_selectAccountLabel"
                            modifier={
                                BROKER_STOCKS_CONTRACT_DROPDOWN_DERIVATIVES_TRANSFER_MODIFIER
                            }
                            onStockContractChange={this.handleAccountChange}
                            options={stockContractOptions.toArray()}
                            placeholder={formatText('transfers-selectAccount')}
                            selectedValue={accountId}
                        />
                        {titularLabel}
                    </div>
                </div>
            );
        } else {
            if (!accountId) return null;
            return (
                <div>
                    <strong>
                        {immAccounts.getIn(['byId', accountId, 'description'])}
                    </strong>
                    <br />
                    <FormattedText
                        value="raAdditionalContribution-raAdditionalContribution_accountDetails"
                        injectedStrings={[
                            CurrencyHelper.getFormattedString(
                                selectedAccountBalance,
                            ),
                            titular,
                        ]}
                    />
                </div>
            );
        }
    }

    buildOTPSection(hasPuntualPeriodicity) {
        const {
            immAccounts,
            immGlobalPosition,
            immAdditionalContribution,
        } = this.props;
        const selectedPortfolio = immAdditionalContribution.get('portfolio');
        const immSelectedAccount = immAdditionalContribution.getIn([
            'hireData',
            'selectedAccount',
        ]);
        const immAccount = immAccounts.getIn([
            'byId',
            immSelectedAccount.get('id'),
        ]);
        const accountId = immSelectedAccount.get('id');

        const amount = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]);
        const destinationAccount =
            immGlobalPosition.getIn([
                'roboAccount',
                selectedPortfolio,
                'ibanComplex',
                'pais',
            ]) +
            immGlobalPosition.getIn([
                'roboAccount',
                selectedPortfolio,
                'ibanComplex',
                'digitodecontrol',
            ]) +
            immGlobalPosition.getIn([
                'roboAccount',
                selectedPortfolio,
                'ibanComplex',
                'codbban',
            ]);
        let operationParams, operationType;
        if (hasPuntualPeriodicity) {
            operationType = PASS_MONEY_ID;
            operationParams = {
                ammount: amount,
                currency: EURO_TEXT,
                originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${immAccount.get(
                    'newProduct',
                )}${immAccount.get('newContractNumber')}`,
                destinationAccount,
            };
        } else {
            operationType = TRANSFER_SEPA_NATIONAL_PERIODICITY_ID;
            operationParams = {
                destinationAccount,
                originAccount:
                    API_ENTERPRISE_NUMBER +
                    API_CENTER +
                    immAccount.get('newProduct') +
                    immAccount.get('newContractNumber'),
                ammount: amount,
                currency: EURO_TEXT,
            };
        }

        const PDFInbase64 = immAdditionalContribution.get('generatedPdf');
        const PDFInbase64Fetching = immAdditionalContribution.get(
            'fetchingPdf',
        );
        const PDFInbase64Error = immAdditionalContribution.get('errorOnPdf');

        return (
            <div key={accountId + destinationAccount + amount}>
                <SignaturePattern
                    printTitleValue={'roboPrintTitle-newGetsionDiscretion'}
                    operationType={operationType}
                    operationParams={operationParams}
                    displayTitle={false}
                    withValidateButton={true}
                    pdfToShow={PDFInbase64}
                    pdfToShowFetching={PDFInbase64Fetching}
                    pdfToShowError={PDFInbase64Error}
                />
            </div>
        );
    }

    buildNoOrderNoRebalancingMessage(hasGoal) {
        const hasGoalKey = hasGoal ? 'Goal' : 'Portfolio';
        const valueKey = `raAdditionalContribution-raAdditionalContribution_disclaimer${hasGoalKey}NoOrdersNoRebalancing`;
        if (!__CONTACT_CENTER__) {
            return (
                <div className="ra-additional-contribution-view__no-rebalacing-message">
                    <FormattedText value={valueKey} />
                </div>
            );
        } else {
            const titleKey = `raAdditionalContribution-raAdditionalContribution_disclaimerTitle${hasGoalKey}NoOrdersNoRebalancing`;
            return (
                <div className="ra-additional-contribution-view__no-rebalacing-message-cc">
                    <BlockInfo>
                        <div className="ra-additional-contribution-view__diclaimer-content">
                            <FormattedText
                                className="ra-additional-contribution-view__disclaimer-title"
                                value={titleKey}
                            />
                            <FormattedText value={valueKey} />
                        </div>
                    </BlockInfo>
                </div>
            );
        }
    }

    buildWizardSection() {
        const {
            immAdditionalContribution,
            immGlobalPosition,
            immSignaturePattern,
            finish,
            history,
        } = this.props;

        const selectedPortfolio = immAdditionalContribution.get('portfolio');
        const isLoading =
            immAdditionalContribution.get('isLoading') ||
            immSignaturePattern.get('isFetchingSMSCode');
        const associatedAccount = immGlobalPosition.getIn([
            'roboAccount',
            selectedPortfolio,
            'name',
        ]);
        const owner = immGlobalPosition.getIn([
            'roboAccount',
            selectedPortfolio,
            'owner',
        ]);
        const currentValue = immGlobalPosition.getIn(
            ['portfolios', selectedPortfolio, 'keyFigures', 'valuation'],
            0,
        );

        const immSelectedAccount = immAdditionalContribution.getIn([
            'hireData',
            'selectedAccount',
        ]);
        const accountId = immSelectedAccount.get('id');

        const amountIsDirty = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'isDirty',
        ]);
        const amount = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]);

        const hasGoal = immGlobalPosition.getIn([
            'portfolios',
            selectedPortfolio,
            'hasGoal',
        ]);

        const immPortfolioState = immGlobalPosition.getIn([
            'portfolios',
            selectedPortfolio,
            'state',
        ]);
        let tradingOnHold, strategyChange, monthlyRebalancing;
        if (selectedPortfolio && immPortfolioState) {
            tradingOnHold = immPortfolioState.get('tradingOnHold');
            strategyChange = immPortfolioState.get('strategyChange');
            monthlyRebalancing = immPortfolioState.get('monthlyRebalancing');
        }

        let noRebalancingMessage;

        if (!tradingOnHold && !strategyChange && !monthlyRebalancing) {
            noRebalancingMessage = this.buildNoOrderNoRebalancingMessage(
                hasGoal,
            );
        }

        const accountBalance = immSelectedAccount.getIn(['balance', 'amount']);
        const accountIsDirty = !!accountId;
        const accountError =
            amountIsDirty && accountIsDirty && accountBalance < amount;
        const amountError = amountIsDirty
            ? amount < RAINITIAL_CONTRIBUTION_MIN ||
              amount > RAINITIAL_CONTRIBUTION_MAX ||
              amount > accountBalance
            : false;
        const hasPuntualPeriodicity =
            immAdditionalContribution.get('periodicity') ===
            CONTRIBUTION_PERIOD_PUNCTUAL;

        const signaturePatternRequired =
            immSignaturePattern.get('requiredSMS') ||
            immSignaturePattern.get('requiredDigits');
        const otpSection =
            selectedPortfolio && accountId
                ? this.buildOTPSection(hasPuntualPeriodicity)
                : null;

        let lastStep;
        let otpWithoutSignature;
        let disableFooterRightContent;
        const isOfficeModeInternal = isPrintOfficeMode();
        if ((accountId && !hasPuntualPeriodicity) || isOfficeModeInternal) {
            const { immPrinter } = this.props;
            const documentationNotPrinted =
                immPrinter.get('documentsPrintedAndSigned') !==
                PRINTED_DOCUMENTS_ANSWER.YES;

            let inputSignatureValue = !immSignaturePattern.get('inputValueSMS');

            disableFooterRightContent =
                !immSignaturePattern.get('isFetchingConfigSuccess') ||
                amountError ||
                accountError ||
                !accountId ||
                (!isOfficeModeInternal && inputSignatureValue) ||
                (isOfficeModeInternal && documentationNotPrinted);

            lastStep = (
                <RAAccordionWizardStep
                    identifier="confirmation"
                    title={
                        !isOfficeModeInternal
                            ? formatText(
                                  'raAdditionalContribution-raAdditionalContribution_confirmation',
                              )
                            : formatText(
                                  'raAdditionalContribution-officeScenarioConfirmation',
                              )
                    }
                    position={WIZARD_POSITION_LAST}
                    icon="icon-firma"
                    hidePrevButton={true}
                    hideNextButton={true}
                >
                    {otpSection}
                </RAAccordionWizardStep>
            );
        } else {
            const signaturePatternContainerClasses = classnames({
                'ra-additional-contribution-view__signature-pattern-hidden':
                    __CONTACT_CENTER__ && isOfficeModeInternal
                        ? false
                        : !signaturePatternRequired,
            });
            otpWithoutSignature = (
                <div className={signaturePatternContainerClasses}>
                    <div className="ra-additional-contribution-view__outer-signature">
                        <div className="ra-additional-contribution-view__outer-signature-header">
                            <i className="ra-additional-contribution-view__outer-signature-icon icon-firma"></i>
                            <div className="ra-additional-contribution-view__outer-signature-header-content">
                                <h3 className="ra-additional-contribution-view__outer-signature-header-title">
                                    {formatText(
                                        'raAdditionalContribution-raAdditionalContribution_confirmation',
                                    )}
                                </h3>
                            </div>
                        </div>
                        <div className="ra-additional-contribution-view__outer-signature-body">
                            {otpSection}
                        </div>
                    </div>
                </div>
            );

            disableFooterRightContent =
                amountError ||
                accountError ||
                !accountId ||
                accountBalance < amount ||
                immAdditionalContribution.get('visibleStep') !== SECOND_STEP;
        }
        const tooltipText = !disableFooterRightContent
            ? formatText('raAdditionalContribution-confirmInfoTooltip')
            : '';

        const portfolios = immGlobalPosition.get('portfolios');
        const availablePortfolios = portfolios.filter(
            portfolio => !portfolio.getIn(['state', 'cancelled']),
        );
        let portfolioSection = <LoadingSection />;

        if (portfolios.size > 0) {
            portfolioSection = (
                <RAPortfolioBox
                    accountName={associatedAccount}
                    accountOwner={owner}
                    currentValue={currentValue}
                    portfolios={availablePortfolios}
                    selectedPortfolio={selectedPortfolio}
                    onPortfolioChange={this.handlePortfolioChange}
                />
            );
        }

        return (
            <div>
                {portfolioSection}
                <RAAccordionWizard
                    immSteps={immAdditionalContribution.get('steps')}
                    cancelPath={MYPROFILE_BROKER_ROBO_URL}
                    finish={this.props.finish}
                    resetStep={this.props.resetStep}
                    setVisibleStep={this.props.setVisibleStep}
                    validateStep={this.props.validateStep}
                    visibleStep={immAdditionalContribution.get('visibleStep')}
                >
                    <RAAccordionWizardStep
                        key="contribution"
                        identifier="contribution"
                        title={formatText(
                            'raAdditionalContribution-raAdditionalContribution_contribution',
                        )}
                        position={WIZARD_POSITION_FIRST}
                        icon="icon-incremento-moderado"
                    >
                        {this.buildContributionStep()}
                    </RAAccordionWizardStep>
                    <RAAccordionWizardStep
                        key="contributionSource"
                        identifier="contributionSource"
                        title={formatText(
                            'raAdditionalContribution-raAdditionalContribution_contributionSource',
                        )}
                        position={
                            hasPuntualPeriodicity && !isOfficeModeInternal
                                ? WIZARD_POSITION_LAST
                                : WIZARD_POSITION_MIDDLE
                        }
                        icon="icon-depositos"
                        hidePrevButton={
                            hasPuntualPeriodicity && !isOfficeModeInternal
                        }
                        hideNextButton={
                            hasPuntualPeriodicity && !isOfficeModeInternal
                        }
                    >
                        {this.buildContributionSourceStep()}
                    </RAAccordionWizardStep>
                    {lastStep}
                </RAAccordionWizard>
                {otpWithoutSignature}
                <div className="row ra-additional-contribution-view__no-rebalacing-message">
                    {noRebalancingMessage}
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <RAFooter
                            cancelPath={GO_BACK_URL}
                            onRightButtonClick={() => finish(history)}
                            disableRightButton={disableFooterRightContent}
                            rightButtonText={formatText(
                                'raAdditionalContribution-ctaConfirm',
                            )}
                            showRightContent={true}
                            tooltipText={tooltipText}
                            loading={isLoading}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildResumeAccount(selectedAccount, selectedAccountAmount) {
        const amountFormatted = (
            <RAOneLineSymbolAmount amountObject={selectedAccountAmount} />
        );
        return (
            <div className="ra-additional-contribution-view__resume-account">
                <div>{selectedAccount}</div>
                <FormattedTextWithComponents
                    value="raAdditionalContribution-accountBalance"
                    injectedComponents={[amountFormatted]}
                />
            </div>
        );
    }

    buildSuccessfulSection() {
        const {
            immAdditionalContribution,
            immGlobalPosition,
            immAccounts,
        } = this.props;
        const contribution = immAdditionalContribution.getIn([
            'hireData',
            'contribution',
            'amount',
        ]);
        const netValueFormatted = (
            <RAOneLineSymbolAmount
                amountObject={buildAmountObject(contribution)}
            />
        );
        const selectedAccountID = immAdditionalContribution.getIn([
            'hireData',
            'selectedAccount',
            'id',
        ]);
        const selectedAccount = immAccounts.getIn([
            'byId',
            selectedAccountID,
            'alias',
        ]);
        const selectedAccountAmount = immAccounts
            .getIn(['byId', selectedAccountID, 'balance'])
            .toJS();
        const selectedPortfolio = immAdditionalContribution.get('portfolio');
        const resumeAccountValue = this.buildResumeAccount(
            selectedAccount,
            selectedAccountAmount,
        );
        const periodicity = immAdditionalContribution.get('periodicity');
        const resumeTitle = formatText(
            'raAdditionalContribution-newContribution',
        );
        const mainButton = formatText(
            'raAdditionalContribution-raAdditionalContribution_SuccessCTA',
        );
        const infoContent = formatText('raAdditionalContribution-infoText');
        let resumeContent, contributionType;

        if (periodicity === CONTRIBUTION_PERIOD_PUNCTUAL) {
            contributionType = formatText('raContributionPeriodicity-punctual');
        } else {
            contributionType = formatText('raContributionPeriodicity-periodic');
        }

        resumeContent = [
            {
                label: formatText('raCancelPlan-resumeDestiny'),
                value: getFirstNChars(
                    immGlobalPosition.getIn([
                        'portfolios',
                        selectedPortfolio,
                        'name',
                    ]),
                    20,
                ),
            },
            {
                label: formatText('raCancelPlan-resumeOwner'),
                value: immGlobalPosition.getIn([
                    'roboAccount',
                    selectedPortfolio,
                    'owner',
                ]),
            },
            {
                label: formatText(
                    'raAdditionalContribution-raAdditionalContribution_contributionType',
                ),
                value: contributionType,
            },
            {
                label: formatText('raCancelPlan-resumeAccount'),
                value: resumeAccountValue,
            },
            {
                label: formatText('raAdditionalContribution-amount'),
                value: netValueFormatted,
            },
        ];

        if (periodicity !== CONTRIBUTION_PERIOD_PUNCTUAL) {
            resumeContent.push({
                label: formatText(
                    'raAdditionalContribution-raAdditionalContribution_periodicity',
                ),
                value: this.getPeriodicityTranslation(periodicity),
            });
        }

        return (
            <RALandingSuccess
                title={resumeTitle}
                resumeContent={resumeContent}
                info={infoContent}
                mainButton={mainButton}
                mainButtonURL={MYPROFILE_BROKER_ROBO_URL}
            />
        );
    }

    handleCloseModalMaintenance() {
        recordLinkV2({
            action: 'click',
            format: 'button',
            component: 'modal/technicalUpdateDeferOperations',
            element: 'understood',
            eventCategory: PROC_RA_NEW_CONTRIBUTION,
            eventAction: 'technicalUpdateDeferOperations',
            eventLabel: 'understood',
        });
        this.setState({
            openModalMaintenance: false,
        });
    }

    render() {
        const {
            immAdditionalContribution,
            immGlobalPosition,
            immFlagBasedFeatures,
        } = this.props;
        const submitSuccessful = immAdditionalContribution.get(
            'submitSuccessful',
        );
        const breadcrumb = this.getBreadcrumb();
        const featureModal = this.buildFeatureModal();
        const goalType = immGlobalPosition.getIn([
            'portfolios',
            immAdditionalContribution.get('portfolio'),
            'goalInformation',
            'goalType',
        ]);
        let content;

        if (submitSuccessful) {
            content = this.buildSuccessfulSection();
        } else {
            content = this.buildWizardSection();
        }

        const hasPeriodicity =
            immAdditionalContribution.get('periodicity') !==
            CONTRIBUTION_PERIOD_PUNCTUAL;
        const successTitle = formatText(
            `raAdditionalContribution-headerSuccessTitle${
                hasPeriodicity ? 'Periodic' : ''
            }`,
        );

        const ffUsPersonOpenBrokerageAccount = immFlagBasedFeatures.get(
            'wealth_roboadvisor_contribution_us_person',
        );

        const contentModal = (
            <div className="ra-additional-contribution-view__content-modal">
                <p>
                    <FormattedText value="raAdditionalContribution-descriptionOneMaintenanceModal" />
                </p>
                <p>
                    <FormattedText value="raAdditionalContribution-descriptionTwoMaintenanceModal" />
                </p>
            </div>
        );

        const contentRender = (
            <div className="ra-additional-contribution-view grid-view">
                <OKModal
                    content={contentModal}
                    isOpen={this.state.openModalMaintenance}
                    onCloseCallback={this.handleCloseModalMaintenance}
                    onPrimaryButtonClick={this.handleCloseModalMaintenance}
                    primaryButtonText="raAdditionalContribution-maintenancePrimaryButton"
                    shouldCloseOnOverlayClick={false}
                    size="small"
                    descriptionAlignment="center"
                    title="raAdditionalContribution-titleMaintenanceModal"
                    titleAlignment="center"
                    footerType="action"
                />
                <div className="container-fluid">
                    <div className="row">
                        <RACover
                            breadcrumb={breadcrumb}
                            success={submitSuccessful}
                            successTitle={successTitle}
                            goalType={goalType}
                            title={formatText(
                                'raAdditionalContribution-newContribution',
                            )}
                        />
                    </div>
                </div>
                <div className="row ra-additional-contribution-view__container">
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">
                                    {content}
                                    {featureModal}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonOpenBrokerageAccount}
                titleKey={'us_person_popup-roboadvisor_contribution_title'}
                description={'us_person_popup-roboadvisor_contribution_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_ROBO_URL)}
            />
        );
    }
}

RAAdditionalContributionView.propTypes = {
    immAdditionalContribution: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    setAdditionalContributionAccount: PropTypes.func.isRequired,
    setContributionDay: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setPortfolio: PropTypes.func.isRequired,
    setRecurringContributionAmount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    getAdditionalContributionPDF: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immAdditionalContribution: state.raAdditionalContribution,
        immGlobalPosition: state.raGlobalPosition,
        immSignaturePattern: state.signaturePattern,
        immAccounts: state.accounts,
        immRAFeatureFlag: state.raFeatureFlag,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPrinter: state.printer,
    }),
    {
        fetchMyInvestments: brokerMyInvestments.fetchMyInvestments,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        finish: raAdditionalContributionActions.finish,
        reset: raAdditionalContributionActions.reset,
        resetStep: raAdditionalContributionActions.resetStep,
        setAdditionalContributionAccount:
            raAdditionalContributionActions.setAdditionalContributionAccount,
        setContributionDay: raAdditionalContributionActions.setContributionDay,
        setPeriodicity: raAdditionalContributionActions.setPeriodicity,
        setPortfolio: raAdditionalContributionActions.setPortfolio,
        setRecurringContributionAmount:
            raAdditionalContributionActions.setRecurringContributionAmount,
        setVisibleStep: raAdditionalContributionActions.setVisibleStep,
        validateStep: raAdditionalContributionActions.validateStep,
        getAdditionalContributionPDF:
            raAdditionalContributionActions.getAdditionalContributionPDF,
    },
)(withRouter(RAAdditionalContributionView));
